import { flagCN, flagGB, flagJP, flagKR, flagVN, packageIcon } from 'images';

export const APP_NAME = 'Portal Services';

export const HOST_CLOUD = process.env.REACT_APP_HOST_CLOUD;
export const BASIC_KEY = process.env.REACT_APP_BASIC_KEY;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID!;

export const ACCESS_TOKEN = 'access_token';
export const REFRESH_TOKEN = 'refresh_token';
export const EXPIRES_IN = 'expires_in';
export const TYPE_TOKEN = 'Bearer';
export const USER_REGISTRATION = 'user_registration';
export const TIME_VERIFICATION_PAGE = '30'; //minute
export const TIME_RESEND = '3'; //minute
export const CURRENT_USER = 'current_user';
export const ORDER_LENGTH = 9;
export const LANG_DEFAULT = 'ko';
export const WEB_SOCKET_URL = new URL(
  `/portal-ws/ws`,
  `${HOST_CLOUD}`,
).toString();

const passwordRegexp =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const emailRegExp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const inputPhoneRegExp = /^[0-9-]+$/;

const specialCharacterReg = /[$&+,:;=?[\]@#|{}'<>.^*()%!-/]/;

const onlyLetterReg = /^[a-zA-Z\s]*$/;

export const widthResize = 768;
export const heightChartTab3 = 210;
export const currencySymbol = '₩';

export const GRANT_TYPE = {
  password: 'password',
  refresh_token: 'refresh_token',
};

const listPhone = [
  { label: '+(81)', value: '+(81)' },
  { label: '+(82)', value: '+(82)' },
  { label: '+(84)', value: '+(84)' },
  { label: '', value: '' },
];

const listCountry = [
  { label: 'England', value: 'England' },
  { label: 'Korea', value: 'Korea' },
  { label: 'Vietnam', value: 'Vietnam' },
  { label: 'Japan', value: 'Japan' },
  { label: 'China', value: 'China' },
];

const amountPoints = [
  { value: '0', label: 0 },
  { value: '1', label: 1 },
  { value: '2', label: 2 },
];

export const ROW_STATUS = {
  NORMAL: null,
  INSERTED: 0,
  UPDATED: 1,
  DELETED: 2,
};

export const CONSTANT = {
  listPhone,
  listCountry,
  passwordRegexp,
  phoneRegExp,
  emailRegExp,
  inputPhoneRegExp,
  specialCharacterReg,
  onlyLetterReg,
  amountPoints,
};

export const ERROR_STATUS = [400, 500, 426, 422];

export const ERORR_UNAUTHORIZED = 401;

export const SUCCESS_STATUS = 200;

export const SUCCESS_STATUS_UPDATE = 201;

export const SUCCESS_STATUS_1 = [200, 201];

export const WIDTH_SIDEBAR_COLLAPSE = '55px';

export const WIDTH_SIDEBAR_EXPAND = '200px';

export const WIDTH_SUBMENU = '265px';

export const WIDTH_SUBMENU_LEVEL_2 = '560px';

export const HEIGHT_LOGO = '60px';

export const HEIGHT_FIXED_MENU = '150px';

export const ROLE_TYPE = [
  { id: 1, name: 'Center Operator', value: 'Center User' },
  { id: 2, name: 'Store', value: 'Market Owner' },
  { id: 3, name: 'Vendor', value: 'Supplier' },
  { id: 4, name: 'Delivery Driver', value: 'Delivery' },
];

export const LIST_LANGUAGE = [
  {
    name: 'English',
    value: 'en',
    icon: flagGB,
  },
  {
    name: '한국어',
    value: 'ko',
    icon: flagKR,
  },
  {
    name: 'Tiếng Việt',
    value: 'vi',
    icon: flagVN,
  },
  {
    name: '日本語',
    value: 'ja',
    icon: flagJP,
  },
  {
    name: '中国人',
    value: 'zh',
    icon: flagCN,
  },
];

// =====
export const USER_TP = {
  '0': 'Super Admin',
  '1': 'User Admin',
};

// =====
export const ACTIVE_TF = {
  true: 'Active',
  false: 'Inactive',
};

export const PACKAGE_TP = {
  '5User': {
    text: '5 Users',
    userCount: 5,
    icon: packageIcon,
    color: '#34B567',
  },
  '10User': {
    text: '10 Users',
    userCount: 10,
    icon: packageIcon,
    color: '#34B567',
  },
  '20User': {
    text: '20 Users',
    userCount: 20,
    icon: packageIcon,
    color: '#34B567',
  },
  '30User': {
    text: '30 Users',
    userCount: 30,
    icon: packageIcon,
    color: '#34B567',
  },
  '40User': {
    text: '40 Users',
    userCount: 40,
    icon: packageIcon,
    color: '#34B567',
  },
  '50User': {
    text: '50 Users',
    userCount: 50,
    icon: packageIcon,
    color: '#34B567',
  },
};

//'0' pause, '1' active,, '2' cancel, '3' expire
export const SERVICE_INSTANCE_STATUS = {
  '0': { text: 'Inactive', color: '#F2F4F7', fontColor: '#344054' },
  '1': { text: 'Active', color: '#ECFDF3', fontColor: '#027A48' },
  // '2': { text: 'Cancel', color: '#BC9064', fontColor: '#FFFFFF' },
  '3': { text: 'Expire', color: '#FF9A41', fontColor: '#FFFFFF' },
  '4': { text: 'Deleted', color: '#FF5B5F', fontColor: '#FFFFFF' },
  '5': { text: 'Not Payment', color: '#EBC52F', fontColor: '#256048' },
  '6': { text: 'Deploy Error', color: '#C1383A', fontColor: '#FFFFFF' },
};

export const NICE_PAY_TYPE = [
  {
    name: 'KRW',
    value: 'KRW',
    paymentMethods: [
      { name: 'CARD', value: 'CARD' },
      { name: 'BANK', value: 'BANK' },
      { name: 'VBANK', value: 'VBANK' },
      { name: 'CELLPHONE', value: 'CELLPHONE' },
      { name: 'SSG_BANK', value: 'SSG_BANK' },
      { name: 'GIFT_CUL', value: 'GIFT_CUL' },
    ],
  },
  // { name: 'CREDIT CARD USD', value: 'CREDIT_CARD_USD', paymentMethods: [] },
  // { name: 'WECHAT USD', value: 'WECHAT_USD_PC', paymentMethods: [] },
  // { name: 'ALIPAY USD', value: 'ALIPAY_USD_PC', paymentMethods: [] },
];
